<template>
  <div :class="{ 'slide-right': isSlideRight }">
    <div class="index_logo">
      <img src="@/assets/images/logo.svg" alt="">
      <div class="title">數位導覽</div>
      <div class="sub_title">Digital Guide</div>
    </div>
    <div class="container">
      {{ getSelectLanguageText() }}
      <div class="language-option" v-for="lang in languages" :key="lang.value"
        :class="{ active: selectedLang === lang.value }" @click="selectedLang = lang.value">
        <span class="lang-text">{{ lang.label }}</span>
        <span class="lang-selected">
          <input type="radio" name="language" :value="lang.value" v-model="selectedLang" />
          <span class="custom-radio"></span>
        </span>
      </div>
      <div class="checkCircle" v-if="selectedLang != ''" @click="lanchoose"><img src="@/assets/images/btn_check.png"
          alt=""></div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'

export default {
  name: 'Language',
  components: {
  },
  data() {
    return {
      selectedLang: '',
      languages: [
        {
          value: 'zh',
          label: '中文',
        },
        {
          value: 'en',
          label: 'English',
        },
        {
          value: 'ja',
          label: '日本語',
        }
      ],
      isSlideRight: false,
      // 安全密鑰（實際應用中應該從環境變數或配置文件讀取）
      secretKey: 'archives-corma',
      // 多語言文字對照表
      languageTexts: {
        zh: {
          selectLanguage: '請選擇語言',
          pleaseSelect: '請選擇語言',
          securityError: '安全驗證失敗，請重新整理頁面'
        },
        en: {
          selectLanguage: 'User Language',
          pleaseSelect: 'Please select a language',
          securityError: 'Security verification failed, please refresh the page'
        },
        ja: {
          selectLanguage: '言語を選択してください',
          pleaseSelect: '言語を選択してください',
          securityError: 'セキュリティ検証に失敗しました。ページを更新してください'
        }
      }
    }
  },
  created() {
    // 頁面載入時設置安全標記
    this.setSecurityToken()
    // 檢查頁面完整性
    this.checkPageIntegrity()
    // 確認是否有選擇過語言
    this.checkPreviousSelection()
  },
  mounted() {
    // 監聽 URL 變化
    this.watchUrlChanges()
    // 定期檢查安全性
    this.startSecurityCheck()
  },
  beforeUnmount() {
    // 清理定時器
    if (this.securityTimer) {
      clearInterval(this.securityTimer)
    }
  },
  methods: {
    checkPreviousSelection() {
      const savedLang = Cookies.get('selectedLanguage')
      if (savedLang) {
        this.selectedLang = savedLang
        if (this.$route.params.pageId) {
          this.$router.push('/' + this.selectedLang + '/login/' + this.$route.params.pageId)
        } else {
          this.$router.push('/' + this.selectedLang + '/login')
        }
      }
    },
    getSelectLanguageText() {
      // 如果沒有選擇語言，預設使用中文
      const currentLang = this.selectedLang || 'zh'
      return this.languageTexts[currentLang]?.selectLanguage || this.languageTexts.zh.selectLanguage
    },
    getCountryFlagText() {
      // 如果沒有選擇語言，預設使用中文
      const currentLang = this.selectedLang || 'zh'
      return this.languageTexts[currentLang]?.countryFlag || this.languageTexts.zh.countryFlag
    },
    // 設置安全令牌
    setSecurityToken() {
      const timestamp = Date.now()
      const randomStr = Math.random().toString(36).substring(2, 15)
      const tokenData = {
        timestamp,
        random: randomStr,
        page: 'language',
        userAgent: navigator.userAgent.substring(0, 50) // 截取部分 UA 避免過長
      }

      // 加密令牌
      const encryptedToken = CryptoJS.AES.encrypt(
        JSON.stringify(tokenData),
        this.secretKey
      ).toString()

      // 儲存到 sessionStorage（頁面關閉就失效）
      sessionStorage.setItem('securityToken', encryptedToken)
      sessionStorage.setItem('lastActivity', timestamp.toString())
    },

    // 驗證安全令牌
    validateSecurityToken() {
      try {
        const token = sessionStorage.getItem('securityToken')
        const lastActivity = sessionStorage.getItem('lastActivity')

        if (!token || !lastActivity) {
          return false
        }

        // 檢查時間是否過期（30分鐘）
        const now = Date.now()
        if (now - parseInt(lastActivity) > 30 * 60 * 1000) {
          return false
        }

        // 解密並驗證令牌
        const decryptedBytes = CryptoJS.AES.decrypt(token, this.secretKey)
        const decryptedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8))

        // 驗證基本資訊
        if (decryptedData.page !== 'language') {
          return false
        }

        return true
      } catch (error) {
        console.error('安全令牌驗證失敗:', error)
        return false
      }
    },

    // 檢查頁面完整性
    checkPageIntegrity() {
      // 檢查關鍵 DOM 元素是否存在
      this.$nextTick(() => {
        const requiredElements = [
          '.index_logo',
          '.container',
          '.language-option'
        ]

        for (const selector of requiredElements) {
          if (!document.querySelector(selector)) {
            this.handleSecurityViolation('DOM元素缺失')
            return
          }
        }
      })
    },

    // 監聽 URL 變化
    watchUrlChanges() {
      let currentUrl = window.location.href

      setInterval(() => {
        if (window.location.href !== currentUrl) {
          currentUrl = window.location.href
          // URL 發生變化，更新安全令牌
          this.setSecurityToken()
        }
      }, 1000)
    },

    // 開始安全檢查
    startSecurityCheck() {
      this.securityTimer = setInterval(() => {
        // 定期驗證令牌
        if (!this.validateSecurityToken()) {
          this.handleSecurityViolation('令牌驗證失敗')
        }

        // 更新最後活動時間
        sessionStorage.setItem('lastActivity', Date.now().toString())
      }, 5 * 60 * 1000) // 每5分鐘檢查一次
    },

    // 處理安全違規
    handleSecurityViolation(reason) {
      console.warn('檢測到安全違規:', reason)

      // 清除敏感資料（但保留 cookie）
      sessionStorage.clear()

      // 顯示警告
      const currentLang = this.selectedLang || 'zh'
      alert(this.languageTexts[currentLang].securityError)

      // 重新載入頁面或跳轉到安全頁面
      window.location.reload()
    },

    // 生成頁面指紋
    generatePageFingerprint() {
      const fingerprint = {
        userAgent: navigator.userAgent,
        language: navigator.language,
        screen: `${screen.width}x${screen.height}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        timestamp: Date.now()
      }

      return CryptoJS.MD5(JSON.stringify(fingerprint)).toString()
    },
    lanchoose() {
      if (this.selectedLang) {
        // 驗證安全性
        if (!this.validateSecurityToken()) {
          this.handleSecurityViolation('跳轉前安全驗證失敗')
          return
        }
        // 生成跳轉令牌
        const jumpToken = this.generateJumpToken()

        Cookies.set('selectedLanguage', this.selectedLang, { expires: 365 })
        sessionStorage.setItem('jumpToken', jumpToken)
        sessionStorage.setItem('jumpTimestamp', Date.now().toString())

        // 根據是否有 pageId 決定跳轉路徑
        this.isSlideRight = true;
        setTimeout(() => {
          if (this.$route.params.pageId) {
            this.$router.push('/' + this.selectedLang + '/login/' + this.$route.params.pageId)
          } else {
            this.$router.push('/' + this.selectedLang + '/login')
          }
        }, 500); // 與動畫時間一致

      } else {
        const currentLang = this.selectedLang || 'zh'
        alert(this.languageTexts[currentLang].pleaseSelect)
      }
    },
    // 生成跳轉令牌
    generateJumpToken() {
      const tokenData = {
        from: 'language',
        to: 'login',
        timestamp: Date.now(),
        fingerprint: this.generatePageFingerprint(),
        language: this.selectedLang
      }

      return CryptoJS.AES.encrypt(
        JSON.stringify(tokenData),
        this.secretKey
      ).toString()
    }
  }
}

</script>
<style scoped>
.index_logo {
  text-align: center;
  margin-top: 20%;
  color: white;
  font-family: 'Noto Sans TC';
}

.index_logo .title {
  margin-top: 15px;
  letter-spacing: 2px;
}

.index_logo .sub_title {
  font-size: 0.8rem;
}

.container {
  width: 80%;
  margin: auto;
  text-align: left;
  color: white;
  margin-top: 10px;
  font-size: 1.1rem;
}

.language-option {
  display: flex;
  align-items: center;
  background: transparent;
  border-radius: 30px;
  padding: 12px 20px;
  width: 100%;
  margin: 20px auto;
  font-family: 'Noto Sans TC', sans-serif;
  cursor: pointer;
  border: 1px solid white;
}

.language-option .flag {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 12px;
}

.language-option .lang-text {
  flex: 1;
  font-size: 1.1rem;
  font-weight: 500;
  letter-spacing: 1px;
}

.language-option .lang-selected {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  position: relative;
}

.language-option .lang-selected input[type="radio"] {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  margin: 0;
  cursor: pointer;
}

.language-option .lang-selected .custom-radio {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: transparent;
  border: 2px solid transparent;
  display: block;
}

.language-option.active {
  background-color: white;
  color: #2E3A59;
}

.language-option.active .lang-selected {
  border: 2px solid #F24E1E;
}

.language-option.active .lang-selected .custom-radio {
  background: #F24E1E;
  border-color: #F24E1E;
}

.checkCircle {
  text-align: center;
  margin-top: 7vh;
}

.slide-right {
  animation: slideRight 0.5s forwards;
}

@keyframes slideRight {
  to {
    transform: translateX(-100vw);
    opacity: 0;
  }
}
</style>
